export default {"src":"/_next/static/media/home_w.4041cb12.svg","height":18,"width":21,"blurWidth":0,"blurHeight":0};